import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nav-header" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("鲲鹏系统")
const _hoisted_4 = { class: "header-avatar" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("退出登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")
  const _component_a_menu_item = _resolveComponent("a-menu-item")
  const _component_a_menu = _resolveComponent("a-menu")
  const _component_a_dropdown = _resolveComponent("a-dropdown")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_icon, {
        name: "logo",
        scale: "3"
      }),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_a_dropdown, null, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, { onClick: _ctx.onMenuChange }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userInfo.roles, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.roleId
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.roleName), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              _createVNode(_component_a_menu_item, null, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.userInfo.name) + " ", 1),
            (_ctx.userInfo.curRole)
              ? (_openBlock(), _createBlock("span", _hoisted_5, "[" + _toDisplayString(_ctx.userInfo.curRole.roleName) + "]", 1))
              : _createCommentVNode("", true),
            _createVNode(_component_icon, {
              name: "drop_Icon",
              scale: 0.5
            }, null, 8, ["scale"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}